import { ChevronDown } from 'lucide-react';

const HERO_IMAGE = 'https://images.unsplash.com/photo-1761489179404-9eed0152f1d1?q=80&w=2560&auto=format&fit=crop';

export default function HeroSection() {
  const scrollToApartments = (e) => {
    e.preventDefault();
    document.querySelector('#appartements')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="accueil"
      data-testid="hero-section"
      className="relative h-screen min-h-[700px] flex items-center justify-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src={HERO_IMAGE}
          alt="Vue pittoresque de Riquewihr, Alsace"
          className="w-full h-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50" />
      </div>

      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
        <p
          className="font-accent text-lg md:text-xl text-white/80 tracking-[0.3em] uppercase mb-6 opacity-0 animate-fade-in-up stagger-1"
        >
          Locations de charme en Alsace
        </p>
        <h1
          className="font-display text-4xl sm:text-5xl md:text-7xl text-white font-semibold leading-tight mb-8 opacity-0 animate-fade-in-up stagger-2"
        >
          Vos Vacances
          <br />
          <span className="italic font-normal">a Riquewihr</span>
        </h1>
        <p
          className="font-body text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-12 leading-relaxed opacity-0 animate-fade-in-up stagger-3"
        >
          Appartements de charme entierement renoves dans des maisons du XVIe siecle,
          au coeur du vignoble alsacien
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center opacity-0 animate-fade-in-up stagger-4">
          <a
            href="#appartements"
            onClick={scrollToApartments}
            data-testid="hero-cta-discover"
            className="inline-block px-10 py-4 bg-wine-700 text-white font-body text-sm uppercase tracking-[0.2em] hover:bg-wine-800 transition-all duration-300 shadow-lg hover:shadow-xl"
          >
            Decouvrir nos appartements
          </a>
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
            }}
            data-testid="hero-cta-reserve"
            className="inline-block px-10 py-4 border-2 border-white/60 text-white font-body text-sm uppercase tracking-[0.2em] hover:bg-white/10 transition-all duration-300"
          >
            Reserver
          </a>
        </div>
      </div>

      <button
        onClick={scrollToApartments}
        data-testid="hero-scroll-down"
        className="absolute bottom-10 left-1/2 -translate-x-1/2 text-white/70 hover:text-white transition-colors animate-bounce"
      >
        <ChevronDown size={32} />
      </button>
    </section>
  );
}
